import { SETTINGS_COMPONENT_LOADERS } from 'src/components/DevicesSettings/settings-component-loaders';
import type { SettingsComponentReference } from 'src/types/Settings';

const COMPONENTS_WITH_LAYOUT_V2 = new Set([
	'auto',
	'auto_gen_2',
	'auto_gen_2_emeter',
	'auto_diffuser_gen_2',
	'schedule_gen_2',
	'schedule_settings',
	'actions',
	'night_mode',
	'night_mode_rgbw',
	'night_mode_g2',
	'virtual_components',
	'webhooks_gen_2',
	'scripts_gen_2',
]);

export function resolveSettingsComponent(
	componentKey: string,
	useLayoutV2: boolean,
): SettingsComponentReference {
	const resolvedKey =
		useLayoutV2 && COMPONENTS_WITH_LAYOUT_V2.has(componentKey) ? `${componentKey}_v2` : componentKey;
	return {
		componentKey: resolvedKey,
		componentLoader: SETTINGS_COMPONENT_LOADERS[resolvedKey],
	};
}
